import React, { FC } from 'react';
import { Box, HStack, PlacementWithLogical, Tooltip } from '@chakra-ui/react';
import { GiTicket } from 'react-icons/gi';

interface Props {
  tooltipPlacement?: PlacementWithLogical;
}

export const TicketBadge: FC<Props> = ({ tooltipPlacement }) => {
  return (
    <Tooltip
      label={
        <Box
          sx={{
            padding: 4,
            backgroundColor: 'gray.1',
            borderRadius: 2,
            color: 'warning.100'
          }}
        >
          Ticket
        </Box>
      }
      portalProps={{ appendToParentPortal: true }}
      placement={tooltipPlacement ?? 'top'}
      zIndex={1000}
    >
      <HStack gap={2} alignItems="center">
        <GiTicket
          style={{
            color: 'var(--chakra-colors-warning-100)',
            width: '24px',
            height: '24px'
          }}
        />
      </HStack>
    </Tooltip>
  );
};
